<div class="chip-list-wrapper">
  <mat-chip-grid #chipList>
    @for (chip of chipList$ | async; track chip) {
      <mat-chip-row class="cardinal-colors">
        {{ chip.text }}
        <button matChipRemove (click)="removeChip(chip)">
          <span class="icon-remove" [inlineSVG]="'/icons/icon-close-no-color.svg'"></span>
        </button>
      </mat-chip-row>
    }
  </mat-chip-grid>
</div>

<mat-form-field class="full-width">
  @if (placeholderAsLabel) {
    <mat-label>{{ placeholder }}</mat-label>
  }
  <input
    matInput
    #autoInput
    type="text"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    [matChipInputFor]="chipList"
    (matChipInputTokenEnd)="addExtra($event)"
    [placeholder]="placeholderAsLabel ? '' : placeholder"
    [matAutocomplete]="auto"
    [formControl]="autoCompleteControl"
  />
</mat-form-field>

<mat-autocomplete [formGroup]="formGroup" #auto="matAutocomplete">
  @for (answer of filterAnswers | async; track answer) {
    <mat-option>
      <label class="label-wrapper" (click)="handleLabelClick($event)">
        <mat-checkbox [formControl]="formGroup.controls[answer.val] | formControl">
          {{ answer.text }}
        </mat-checkbox>
      </label>
    </mat-option>
  }
</mat-autocomplete>

@if (formGroup.touched && getFirstControlWithError('min', formGroup); as control) {
  <mat-error>
    {{ control.errors?.message }}
  </mat-error>
}
@if (formGroup.touched && getFirstControlWithError('max', formGroup); as control) {
  <mat-error>
    {{ control.errors?.message }}
  </mat-error>
}
